export default "__VITE_ASSET__DI0TQDD7__"